import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxh3x7swpa: FaireProductEntity = {
  token: "p_fxh3x7swpa",
  type: "product",
  name: "Ruffled Hem Long Sleeve Sweater Button-Down Cardigan",
  brandToken: "b_1ihdo3a4lt",
  brandName: "Lalavon",
  imageUrl:
    "https://cdn.faire.com/fastly/6b7e2c7fc5e8d85d00b555f6e4ac28330cc16ce1aad0a3dec64f92a0f37badab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a10085ccd1ebc120f5cd9af0ab960fe4be99f827962958b8d33114f7dc82703.jpeg",
    "https://cdn.faire.com/fastly/be7403e2124eef83edac05901dd29da1202546800cbacf18dac1b954eb2148f9.jpeg",
    "https://cdn.faire.com/fastly/5d44299d4eb989024007fcd3e0650c912fad4a6b698f4562fb41a2bfe8a44369.jpeg",
    "https://cdn.faire.com/fastly/b155ad58d5395d121d54b370ea1bfd42de1c400655e8a1c15c43a1840230b283.jpeg",
    "https://cdn.faire.com/fastly/c95d57c1ed3be307d2bf28e079efb857a8c3b58ccd4c80a01977cb746a8a30b9.jpeg",
    "https://cdn.faire.com/fastly/9696ae63390e7fbee831ce0ac18e3480c4c2fd3a4b673cbc2e87bdf364b7ae21.jpeg",
    "https://cdn.faire.com/fastly/f84ecfe9db5856b5627150b999ec556368feb833f0ee5d821e50854d5276ea6d.jpeg",
    "https://cdn.faire.com/fastly/2053efb2d1614ece49d968912303bfff05d5ca707d7a6e8f0da745fc3aeaad46.jpeg",
    "https://cdn.faire.com/fastly/75e789dac8455b8b660065f2ebffa4f4068cccb2f70a28824cdb62935199e5cc.jpeg",
    "https://cdn.faire.com/fastly/4685d2cb9216be9075c03ab3631f5db51256a379082a0254f89cf6c9538ac277.jpeg",
    "https://cdn.faire.com/fastly/35808a871319721b969ab71265dd44a0b5447279de701013c60d918195aa14e6.jpeg",
    "https://cdn.faire.com/fastly/3cf68aabb0e9ad6c9c8538e5e5fd6734b9283b4265c13d30a1b43bdfc4c53e9e.jpeg",
    "https://cdn.faire.com/fastly/d422a26d77e5e850c89768427702831dc1aefebdf74430d6c0e742217ad9e6f6.jpeg",
    "https://cdn.faire.com/fastly/4e3b3ab2905821dbd66c3cefbf94db1fa2cd91c64c84f99d8b6325ebfe6d4c2f.jpeg",
    "https://cdn.faire.com/fastly/f9deb5cf7db0e2ef6745ac24a2bef7dd84b4d9d6db148b9d4a529acc6b5a9374.jpeg",
    "https://cdn.faire.com/fastly/8c0f5fbf95fd70dfa23e63d3f3a07fde219f5a3efa0a300d2323d559184af2d4.jpeg",
    "https://cdn.faire.com/fastly/e72381960c65af3fe4bd44de7c13173281b7ff123d3df7b7a0f46f9d509529c4.jpeg",
    "https://cdn.faire.com/fastly/5467db91ac69b2d5b3b8f993b8c79cbb8cc301c8afbb91d59014e1f5db5a3da3.jpeg",
    "https://cdn.faire.com/fastly/94d0152e63d583aa434958475fa7f1a9d5c857087faf9b528fa29ae5d22f5b4c.jpeg",
  ],
  priceDollars: 142.5,
  description:
    "Add warmth and style to your wardrobe with this Long Sleeve Sweater Button-Down Cardigan. Crafted from soft, cozy knit fabric, this cardigan features a classic button-down design with long sleeves for extra comfort. Perfect for layering over your favorite tops or wearing solo, it offers a versatile, chic look that transitions easily from casual to dressy.\n\nPair with jeans or skirts for a polished, cozy outfit.",
  tags: [],
  msrpDollars: 285,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:57.310Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
